import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, Paper, Link } from "@mui/material";

export default function TermCondition(props: any) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  const settings = useSelector(state => state.settingsdata.settings);

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 4 }}>
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, borderRadius: 2 }}>
          <Box sx={{ direction: isRTL ? 'rtl' : 'ltr' }}>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                mb: 3,
                textAlign: isRTL ? 'right' : 'left',
                color: 'text.primary'
              }}
            >
              {t('term_condition')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para1')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading1')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para2')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading2')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para3')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading3')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para4')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading4')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para5')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading5')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para6')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading6')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para7')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading7')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para8')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading8')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para9')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading9')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para10')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading10')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para11')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading11')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para12')}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                textAlign: isRTL ? 'right' : 'left',
                mt: 2,
                mb: 1,
                color: 'text.primary'
              }}
            >
              {t('term_condition_heading12')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para13')}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                textAlign: isRTL ? 'right' : 'left',
                mb: 2,
                lineHeight: 1.8,
                color: 'text.secondary'
              }}
            >
              {t('term_condition_para14')}
              {settings && settings.contact_email && (
                <Link
                  href={"mailto:" + settings.contact_email}
                  sx={{
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    ml: 0.5,
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  {settings.contact_email}
                </Link>
              )}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}